
export default {
  name: 'cbdcHome',
  components: {},
  data () {
    return {
      productBgList: [
        {
          id: 'c-end',
          title: this.$t('nav.Cend'),
          url: require('@/static/images/applicationIntroduction/c-end.png'),
        },
        {
          id: 'b-end',
          title: this.$t('nav.Bend'),
          url: require('@/static/images/applicationIntroduction/b-end.png'),
        },
        {
          id: 'g-end',
          title: this.$t('nav.Gend'),
          url: require('@/static/images/applicationIntroduction/g-end.png'),
        }
      ],
    }
  },
  computed: {
    // mainHeadline () {
    //   return this.$t('cbdc.home.mainHeadline')
    // },
    // nextHeadline () {
    //   return this.$t('cbdc.home.nextHeadline')
    // },
    // productList () {
    //   return this.$t('cbdc.home.productList')
    // }
  },
  mounted () {
  },
  methods: {
    // 了解更多定义
    goMore (id) {
      this.$router.push({ path: '/cbdc/' + id })
    },
  }
}
